import {trail} from '../path/shapes';
import {pickTrail} from '../util/pickPath';
import markMultiItemPath from './markMultiItemPath';

export default markMultiItemPath('trail', trail, pickTrail);
